/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Slide1title1Inputs */

const he_extension_slide1title1 = /** @type {(inputs: Extension_Slide1title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`היסטוריית מחירים מפורטת`)
};

const en_extension_slide1title1 = /** @type {(inputs: Extension_Slide1title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detailed Price History`)
};

/**
* | output |
* | --- |
* | "Detailed Price History" |
*
* @param {Extension_Slide1title1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_slide1title1 = /** @type {((inputs?: Extension_Slide1title1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Slide1title1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_slide1title1(inputs)
	return en_extension_slide1title1(inputs)
});
export { extension_slide1title1 as "extension_slide1Title" }